import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

class Faq extends React.Component {
    
    render() {
        return (
            <>
                <LandingHeader />

                <div className="about-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="about-items">
                                <div className="col-md-12 about-info">
                                    <h2><span>FAQs</span></h2>
                                    <ul style={{"marginBottom": "15px"}}>
                                        <h4 style={{"marginBottom": "5px"}}>1. Who can use this site?</h4>
                                        <blockquote>Any user who has requirements for URL shortening and link tracking are free to use this website.</blockquote>
                                    </ul>
                                    <ul style={{"marginBottom": "15px"}}>
                                        <h4 style={{"marginBottom": "5px"}}>2. Do I need to pay anything using it?</h4>
                                        <blockquote>No, this site is free for use and stay as it is forever.</blockquote>
                                    </ul>
                                    <ul style={{"marginBottom": "15px"}}>
                                        <h4 style={{"marginBottom": "5px"}}>3. What features I will get by using it?</h4>
                                        <blockquote>By using this site you shall shortened urls for your links and link tracking based on the city and country your visitors came from.</blockquote>
                                    </ul>
                                    <ul style={{"marginBottom": "15px"}}>
                                        <h4 style={{"marginBottom": "5px"}}>4. What are the benefits of using this site?</h4>
                                        <blockquote>This can be useful for tracking your marketing campaigns and better analyze and decide on the results your further approach.</blockquote>
                                    </ul>
                                    <ul style={{"marginBottom": "15px"}}>
                                        <h4 style={{"marginBottom": "5px"}}>5. Who operates this site?</h4>
                                        <blockquote>This site is currently operated by Shouvik Sarkar but at some stage this hsould be operated under a business name.</blockquote>
                                    </ul>
                                    <ul style={{"marginBottom": "15px"}}>
                                        <h4 style={{"marginBottom": "5px"}}>6. Is the data entered protected?</h4>
                                        <blockquote>Yes, the data you provide will be protected will never be compromised. We only ask for name and email for using the site.</blockquote>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter />
            </>
        );
    }
}

export default Faq;
